import {findWork, FindWorkResponseData} from "../../../utils/awsAmplifyUtil";
import useFetchAllQuery, {Status, useFetchAllQueryHelper} from "../../../hooks/useFetchAllQuery";

export interface UseWorkModelByInstance {
  onChange: (newData: FindWorkResponseData<'model'>[], newStatus: Status) => void;
  workInstanceIds: string[];
  enableAutoFetch?: boolean;
  initialStatus?: Status;
}

export function useWorkModelByInstance(params: UseWorkModelByInstance) {
  const result = useFetchAllQuery({
    queryFn: (query) => findWork(
      'model',
      {
        version: "work-user",
        queryAttr: {
          'instance-id': {
            $in: params.workInstanceIds
          }
        }
      },
      query
    ),
    needToFetchMore: (data, limit) => Object.entries(data?.items ?? {}).length === limit,
    enableAutoFetch: params.enableAutoFetch,
  });
  const helperResult = useFetchAllQueryHelper({
    onChange: params.onChange,
    data: result.data,
    status: result.status,
    initialStatus: params.initialStatus,
  })

  return {
    ...result,
    ...helperResult,
  };
}
